export class CustomerTree {
	id: number;
	name: string;
	alternateName: string;
	children: CustomerTree[];
	parentId: number;
	type: string;
	languages: string;
	timeZone: string;
}
